import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-252">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/3jKJN1jMaytrUmd4KAtFJw/baner-fais.png")'
    }} data-id="element-253">
        <div className="absolute inset-0 bg-primary/70 mix-blend-multiply" data-id="element-254" />
        <div className="absolute inset-0 bg-gradient-to-b from-primary/80 via-primary/30 to-primary/80" data-id="element-255" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-257">
          <div className="mb-6 flex items-center space-x-3 opacity-80" data-id="element-258">
            <div className="h-px w-8 bg-white/50" data-id="element-259" />
            <span className="text-white/80 font-medium text-sm tracking-widest uppercase" data-id="element-260">
              Національна спортивна федерація
            </span>
            <div className="h-px w-8 bg-white/50" data-id="element-261" />
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-262">
            Федерація Альпінізму <br data-id="element-263" />і Скелелазіння України
          </h1>

          <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto mb-2 font-medium" data-id="element-264">
            Офіційний представник України в UIAA та IFSC
          </p>

          <p className="text-base text-white/50 max-w-2xl mx-auto mb-10" data-id="element-265">
            Розвиток альпінізму, скелелазіння та льодолазіння в Україні з 1991
            року
          </p>

          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-266">
            <Link to="/login" className="inline-flex items-center justify-center px-8 py-3 text-sm font-semibold text-primary bg-white rounded-md hover:bg-gray-100 transition-colors shadow-sm" data-id="element-267">
              Стати членом
              <ArrowRight className="ml-2 h-4 w-4" data-id="element-268" />
            </Link>
            <a href="#about" className="inline-flex items-center justify-center px-8 py-3 text-sm font-semibold text-white border border-white/30 rounded-md hover:bg-white/10 transition-colors" data-id="element-269">
              Про федерацію
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 opacity-50" data-id="element-270">
        <ChevronDown className="h-6 w-6 text-white" data-id="element-271" />
      </motion.div>
    </section>;
}